import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronDown, Search } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import SearchModal from './SearchModal';
import RegionSelector from './RegionSelector';

const Header = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleNavClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    { name: 'Digital Transformation', url: '/digital-transformation' },
    { name: 'Cloud Services', url: '/cloud-services' },
    { name: 'AI & Machine Learning', url: '/ai-machine-learning' },
    { name: 'Cybersecurity', url: '/cybersecurity' },
    { name: 'Data & Analytics', url: '/data-analytics' },
    { name: 'Application Development', url: '/application-development' }
  ];

  const industries = [
    { name: 'Banking & Financial Services', url: '/banking-financial-services' },
    { name: 'Healthcare & Life Sciences', url: '/healthcare-life-sciences' },
    { name: 'Manufacturing & Industry 4.0', url: '/manufacturing' },
    { name: 'Retail & Consumer Goods', url: '/retail' },
    { name: 'Energy & Utilities', url: '/energy' },
    { name: 'Government & Public Sector', url: '/government' }
  ];

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            <button className="logo-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }}>
              <Logo size="medium" />
            </button>

            <nav className="desktop-nav">
              <div className="nav-item dropdown"
                   onMouseEnter={() => setActiveDropdown('services')}
                   onMouseLeave={() => setActiveDropdown(null)}>
                <span>Services <ChevronDown size={16} /></span>
                {activeDropdown === 'services' && (
                  <div className="dropdown-menu">
                    {services.map(service => (
                      <button key={service.name} onClick={() => handleNavClick(service.url)}>
                        {service.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="nav-item dropdown"
                   onMouseEnter={() => setActiveDropdown('industries')}
                   onMouseLeave={() => setActiveDropdown(null)}>
                <span>Industries <ChevronDown size={16} /></span>
                {activeDropdown === 'industries' && (
                  <div className="dropdown-menu">
                    {industries.map(industry => (
                      <button key={industry.name} onClick={() => handleNavClick(industry.url)}>
                        {industry.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <button onClick={() => handleNavClick('/insights')}>Insights</button>
              <button onClick={() => handleNavClick('/careers')}>Careers</button>
              <button onClick={() => handleNavClick('/about')}>About</button>
              <button onClick={() => handleNavClick('/contact')}>Contact</button>
            </nav>

            <div className="header-actions">
              <button className="search-btn" onClick={() => setIsSearchOpen(true)}>
                <Search size={20} />
              </button>
              <RegionSelector />
              <button className="mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {isMobileMenuOpen && (
            <div className="mobile-menu">
              <div className="mobile-nav">
                <button onClick={() => handleNavClick('/services')}>Services</button>
                <button onClick={() => handleNavClick('/industries')}>Industries</button>
                <button onClick={() => handleNavClick('/insights')}>Insights</button>
                <button onClick={() => handleNavClick('/careers')}>Careers</button>
                <button onClick={() => handleNavClick('/about')}>About</button>
                <button onClick={() => handleNavClick('/contact')}>Contact</button>
              </div>
            </div>
          )}
        </div>
      </header>
      
      <SearchModal isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
};

export default Header;